import { Activity, Bot, Coins, Zap } from 'lucide-react'
import { StatCard } from '@/components/design-system/StatCard'
import { formatCurrency, formatDateTime, formatNumber } from '../format'
import type { CostSummary as Summary } from '../types'

interface Props {
  summary: Summary
}

export default function CostSummary({ summary }: Props) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
      <StatCard label="Custo" value={formatCurrency(summary.totalSpend)} icon={<Coins />} colorScheme="green" size="small" />
      <StatCard label="Chamadas" value={formatNumber(summary.totalEvents)} icon={<Activity />} colorScheme="blue" size="small" />
      <StatCard label="Tokens" value={formatNumber(summary.totalTokens)} icon={<Zap />} colorScheme="gray" size="small" />
      <StatCard label="Workers" value={formatNumber(summary.workersCount)} icon={<Bot />} colorScheme="purple" size="small" />
      <div className="col-span-2 lg:col-span-4 text-xs text-muted-foreground">
        Último evento: {formatDateTime(summary.latestEventAt)}
      </div>
    </div>
  )
}
